<template>
  <div 
    :id="id + '___FB_badge_'" 
    class="custom-badge"
  >
    <span v-if="copy !== null" class="badge" :class="[stylingBg, stylingText]">
      {{copy}}
    </span>
    <span v-else class="badge" :class="[stylingBg, stylingText]">
      <slot />
    </span>
  </div>
</template>

<script>
  export default {
    name: 'FabricBadge',
    props: {
      id: {
        type: [String],
        default: () => { return '' + Math.floor(Math.random() * Date.now())},
      },
      stylingBg: {
        type: String,
        default: '',
      },
      stylingText: {
        type: String,
        default: '',
      },
      copy: {
        type: [Number, String],
        default: null,
      },
    },
  }
</script>
